import { PRIVACY_POLICY_URL, TERMS_URL } from "../../platform/legal";
import { AuthDivider, AuthFooter, AuthNote } from "../../ui/AuthShell";
import { EmailCodeForm } from "./EmailCodeForm";
import { GoogleButton } from "./GoogleButton";

export interface SignInChoicesProps {
  /** Where Google brings the browser back to; the email code signs in on this page. */
  redirect: string;
  /** Live's words above the email: "or log in with email" on sign-in, "or sign in with email" for an invitation. */
  divider: string;
  onSignedIn: () => void;
  footer?: string;
}

/**
 * Google or an email code, nothing else (D1), with the terms and the invite-only note: the sign-in
 * screen's, and the invitation link's when signed out (spec teams/invite-by-email).
 */
export function SignInChoices({ redirect, divider, onSignedIn,
  footer = "Created.ai is invite-only. Sign in with the email your invitation was sent to.",
}: SignInChoicesProps) {
  return (
    <>
      <GoogleButton redirect={redirect} />
      <AuthDivider label={divider} />
      <EmailCodeForm onSignedIn={onSignedIn} />
      <AuthNote>
        By continuing you agree to the{" "}
        <a href={TERMS_URL} target="_blank" rel="noopener noreferrer">
          Terms
        </a>{" "}
        and{" "}
        <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
        .
      </AuthNote>
      <AuthFooter>
        {footer}
      </AuthFooter>
    </>
  );
}
